import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ZenObservable } from 'zen-observable-ts';
import { appConstants } from '../../../shared/constants/constants';
import {
  APIService,
  CreateNotificationInput,
  UpdateDocumentInput,
  UpdateCisternaInput,
  UpdateCisternaMutation,
  Cisterna,
  Document,
  GetArchiveQuery,
  Master,
} from '../../../app-sync.service';
import { FeedbacksService } from '../../../shared/feedbacks/feedbacks.service';
import { CisternasService } from '../cisternas.service';
import { ModalsService } from '../../../shared/modals/modals.service';
import { DocumentsService } from '../../documents/documents.service';
import { UsersService } from '../../users/users.service';
import { EditionsService } from '../../../shared/services/editions.service';
import { MasterService } from '../../master/master.service';
import { ApiRequestsService } from '../../../shared/services/api-requests.service';
import { FormsService } from '../../../shared/services/forms.service';
import { ArchivesService } from '../../../shared/services/archives.service';
import { DocumentFromForms } from '../../../shared/interfaces/document-from-forms';
import { CommonsService } from '../../../shared/services/commons.service';
import { atLeastOneSelected } from 'src/app/shared/validators/at-least-one-selected-validator';
import { FeedbackClasses } from 'src/app/shared/interfaces/feedback-classes';
import { isReprocesingAvailable } from 'src/app/shared/functions/reprocesing';
import { FormValidators } from 'src/app/shared/interfaces/form-validators';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { maxDateTodayValidator } from 'src/app/shared/validators/max-date-today-validator';

@Component({
  selector: 'app-cisterna-details',
  templateUrl: './cisterna-details.component.html',
  styleUrls: ['./cisterna-details.component.css'],
})
export class CisternaDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('cisternaModal', { static: false }) cisternaModal:
    | TemplateRef<any>
    | undefined;
  @ViewChild('updateCisternaAttributeModal', { static: false })
  updateCisternaAttributeModal: TemplateRef<any> | undefined;
  @ViewChild('updateCisternaAttributeUsesModal', { static: false })
  updateCisternaAttributeUsesModal: TemplateRef<any> | undefined;
  @ViewChild('updateCisternaFuelsAttributesModal', { static: false })
  updateCisternaFuelsAttributesModal: TemplateRef<any> | undefined;
  @ViewChild('archiveCisternaModal', { static: false })
  archiveCisternaModal: TemplateRef<any> | undefined;
  @ViewChild('cisternaArchiveDetailsModal', { static: false })
  ArchiveDetailsModal: TemplateRef<any> | undefined;
  @ViewChild('cisternaArchivedocumentViewer', { static: false })
  documentViewer: TemplateRef<any> | undefined;
  currentYear: number = new Date().getFullYear();
  isAdmin: boolean = false;
  isApprover: boolean = false;
  isCarrier: boolean = false;
  isBeingRejected: boolean = false;
  isGettingCisterna: boolean = false;
  modalMessage: string = '';
  modalQuestion: string = '';
  modalTitle: string = '';
  modalWithComment: boolean = false;
  archiveForm: FormGroup;
  commentForm: FormGroup;
  updateAttributeForm: FormGroup;
  cisterna: Cisterna;
  cisternaNeedsApproval: boolean = false;
  cisternaCanBeRejected: boolean = false;
  showBlockingMotives: boolean = false;
  hasComment: boolean = false;
  showComment: boolean = false;
  cisternaArchive: GetArchiveQuery | undefined;
  isGettingURL: boolean = false;
  pdfSource: string = '';
  agreement: any = {};
  isColapsed: boolean = true;
  hasAgrement: boolean = false;
  commercialAgreementsStatuces = appConstants.ACstatus;
  master: any = {};

  private selectedCisternaChangedSubscription: Subscription =
    new Subscription();
  private onUpdateCisternaListener: ZenObservable.Subscription =
    new Subscription();
  private requestSucceededSubscription: Subscription = new Subscription();
  business: string = '';
  fuelAttributeToChange: 'SECDate' | 'SECFolio' | 'SECCertificate' | null =
    null;
  updateFuelsAttributesForm: FormGroup;

  constructor(
    private api: APIService,
    private apiRequestsService: ApiRequestsService,
    private cisternasService: CisternasService,
    private documentsService: DocumentsService,
    private editionsService: EditionsService,
    private feedbacksService: FeedbacksService,
    private masterService: MasterService,
    private modalsService: ModalsService,
    private route: ActivatedRoute,
    private router: Router,
    private usersService: UsersService,
    private formsService: FormsService,
    private archivesService: ArchivesService,
    private commonsService: CommonsService,
    private validatorsService: ValidatorsService
  ) {
    this.cisterna = this.cisternasService.getSelectedCisterna();
    this.archiveForm = new FormGroup({
      motiveForArchiving: new FormControl(null),
      comment: new FormControl(null),
      documents: new FormArray([
        new FormGroup({
          documentMasterValueId: new FormControl(null),
          documentName: new FormControl(null),
          documentIssueDate: new FormControl(null),
          documentExpirationDate: new FormControl(null),
          documentFile: new FormControl(null),
          documentSourceFile: new FormControl(null),
        }),
      ]),
    });
    this.commentForm = new FormGroup({
      comment: new FormControl(null),
    });
    this.updateAttributeForm = new FormGroup({
      center: new FormControl(null),
    });
    this.updateFuelsAttributesForm = new FormGroup({
      SECCertificate: new FormControl(null),
      SECDate: new FormControl(null),
      SECFolio: new FormControl(null),
    });
  }

  async ngOnInit() {
    this.business = this.usersService.business.value;
    this.master = this.masterService.getMaster();
    this.selectedCisternaChangedSubscription =
      this.cisternasService.selectedCisternaChanged.subscribe(
        (cisterna: Cisterna) => {
          this.cisterna = cisterna;
          if (this.cisterna.archiveId) {
            this.getcisternaArchive(this.cisterna.archiveId);
          }
          this.setCisternaSituation();
          this.hasAgrement = false;
          if (this.hasAccessAC()) {
            this.getAgrement(this.cisterna.cisternaId);
          }
        }
      );

    this.isAdmin = this.usersService.isAdmin;
    this.isApprover = this.usersService.isApprover;
    this.isCarrier = this.usersService.isCarrier;

    await this.updateSelectedCisterna();

    // Subscripción a actualizaciones de la Cisterna
    this.onUpdateCisternaListener = this.api
      .OnUpdateCisternaListener(
        this.cisternasService.getSelectedCisternaFilterForSubscriptions()
      )
      .subscribe((response) => {
        if (response) {
          this.cisternasService.refreshSelectedCisterna();
        }
      });

    // Subscripción a consultas de API exitosas
    this.requestSucceededSubscription =
      this.apiRequestsService.requestSucceeded.subscribe(
        (requestSucceeded: boolean): void => {
          if (requestSucceeded) {
            this.onRefreshCisterna();
          }
        }
      );
  }

  /**
   * Actualiza la Cisterna seleccionada.
   * @return {Promise}
   * @private
   */
  private async updateSelectedCisterna(): Promise<void> {
    this.isGettingCisterna = true;
    await this.cisternasService.refreshSelectedCisterna().then(() => {
      this.setCisternaSituation();
      this.isGettingCisterna = false;
    });
  }

  /**
   * Ejecuta el modal de aprobación de una cisterna y pide su
   * actualización en caso de ser aprobado.
   * @return {Promise}
   */
  async onApproveCisterna(): Promise<void> {
    this.initCommentForm();
    this.modalTitle = appConstants.cisterna.modalMessages.approve.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.approve.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage = appConstants.cisterna.modalMessages.approve.message;
    this.modalWithComment = true;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.cisternaModal
    );

    if (modalResult) {
      this.isGettingCisterna = true;
      await this.updateCisterna('approve', this.commentForm.value.comment);
    }
  }

  /**
   * Ejecuta el modal de rechazo de una cisterna y pide su
   * actualización en caso de ser rechazado.
   * @return {Promise}
   */
  async onRejectCisterna(): Promise<void> {
    this.isBeingRejected = true;
    this.initCommentForm();
    this.modalTitle = appConstants.cisterna.modalMessages.reject.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.reject.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage = appConstants.cisterna.modalMessages.reject.message;
    this.modalWithComment = true;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.cisternaModal
    );

    if (modalResult) {
      this.isGettingCisterna = true;
      const newNotification = this.commentForm.value;
      const today: Date = new Date();
      const todayTimestamp: string = Math.floor(
        today.getTime() / 1000
      ).toString();
      const creatNotificationInput: CreateNotificationInput = {
        businessId: this.cisterna.business,
        notificationId:
          'CISTERNA#' + this.cisterna.cisternaId + '#' + todayTimestamp,
        status: 'TO_BE_SENT',
        model: 'CISTERNA',
        motive: 'APPROVE#REJECTED',
        cisternaId: this.cisterna.cisternaId,
        comment: newNotification.comment,
      };

      await this.api
        .CreateNotification(creatNotificationInput)
        .then(async (): Promise<void> => {
          await this.updateCisterna('reject', newNotification.comment);
        });
    }

    this.isBeingRejected = false;
  }

  /**
   * Ejecuta el modal de archivado de una cisterna y dirige
   * al componente de edición en caso de ser archivado.
   * @return {Promise}
   */
  async onArchiveCisterna(): Promise<void> {
    this.archivesService.setArchiving(true);
    this.initArchiveForm();
    this.modalTitle = appConstants.cisterna.modalMessages.archive.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.archive.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage = appConstants.cisterna.modalMessages.archive.message;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.archiveCisternaModal
    );

    if (modalResult) {
      console.log(' onArchiveCisterna @ cisterna-details.component ');
      console.log(this.archiveForm.value);
      if (this.archiveForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }

      let documents: DocumentFromForms[] = [];
      if (this.archiveForm.get('documents') !== null) {
        documents = this.archiveForm.value.documents.slice();
      }

      // 1. Se crea el archivo.
      await this.archivesService.createArchive(
        this.cisterna,
        this.archiveForm.value.motiveForArchiving,
        this.archiveForm.value.comment,
        documents
      );

      // 2. Dirigimos a la creación de la nueva entidad.
      this.router
        .navigate(['../new'], { relativeTo: this.route })
        .then(() => console.log('navigate to new'));
    }
  }

  /**
   * Actualiza una cisterna.
   * @param {string} action Acción a realizar, puede ser 'approve' o 'reject'.
   * @param {string} comment Comentario de aprobación o rechazo.
   * @return {Promise}
   * @private
   */
  private async updateCisterna(
    action: 'approve' | 'reject',
    comment: string | null = null
  ): Promise<void> {
    this.isGettingCisterna = true;
    let newCisternaStatus: string;
    let feedbackMessage: string = `Cisterna ${this.commonsService.getIdentification(
      this.cisterna.sapId!,
      this.cisterna.licensePlate
    )} `;
    let catchFeedbackMessage: string = `Error al _ cisterna ${this.commonsService.getIdentification(
      this.cisterna.sapId!,
      this.cisterna.licensePlate
    )}`;

    switch (action) {
      case 'approve':
        // Se cambia el estado de la Cisterna a "Procesando"
        newCisternaStatus = `${this.cisterna.business}_${appConstants.entity.codes.inProcess}`;
        feedbackMessage = feedbackMessage + 'aprobado. Actualizando';
        catchFeedbackMessage = catchFeedbackMessage.replace('_', 'aprobar');
        break;
      case 'reject':
        // Se cambia el estado de la Cisterna a "Rechazado"
        newCisternaStatus = `${this.cisterna.business}_${appConstants.entity.codes.rejected}`;
        feedbackMessage = feedbackMessage + 'rechazado. Enviando notificación';
        catchFeedbackMessage = catchFeedbackMessage.replace('_', 'rechazar');
        break;
    }

    const updateCisternaInput: UpdateCisternaInput = {
      cisternaId: this.cisterna.cisternaId,
      status: newCisternaStatus,
      comment: comment,
      updatedBy: this.usersService.getActiveUser().userId,
    };

    await this.api
      .UpdateCisterna(updateCisternaInput)
      .then(async (cisterna: UpdateCisternaMutation): Promise<void> => {
        this.feedbacksService.showFeedback(feedbackMessage, 'info');

        if (action === 'approve') {
          // Se cambia el estado de los documentos con estado "Por Aprobar"
          // al estado "Procesando"
          for (let document of cisterna.documents!.items) {
            if (
              document?.status ===
              `${cisterna.business}_${appConstants.document.codes.toBeApproved}`
            ) {
              const updateDocumentInput: UpdateDocumentInput = {
                documentId: document.documentId,
                name: document.name,
                status: `${cisterna.business}_${appConstants.document.codes.inProcess}`,
              };
              await this.documentsService.updateDocument(updateDocumentInput);
            }
          }
        }

        // Actualizamos la Cisterna seleccionada.
        await this.updateSelectedCisterna();
      })
      .catch((response: any): void => {
        this.feedbacksService.showErrorFeedbacks(
          response,
          catchFeedbackMessage
        );
      });
  }

  /**
   * Ejecuta el modal de edición de atributos de la Cisterna.
   * @return {Promise}
   */
  async onUpdateCisterna(): Promise<void> {
    this.initUpdateAttributeForm();

    this.modalTitle = appConstants.cisterna.modalMessages.edit.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.edit.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage = appConstants.cisterna.modalMessages.edit.message;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.updateCisternaAttributeModal
    );

    if (modalResult) {
      if (this.updateAttributeForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }

      const patchedCisterna = this.updateAttributeForm.value;
      const payload: { [key: string]: string } = {
        center: patchedCisterna.center,
      };

      this.apiRequestsService.updateEntity(
        this.cisterna.business,
        this.cisterna.__typename,
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        ),
        payload
      );
    }
  }
  async onUpdateCisternaUses(): Promise<void> {
    this.initUpdateAttributeUsesForm();

    this.modalTitle = appConstants.cisterna.modalMessages.edit.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.edit.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage =
      appConstants.cisterna.modalMessages.edit.message.replace('y SAP', '');

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.updateCisternaAttributeUsesModal
    );

    if (modalResult) {
      if (this.updateAttributeForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }
      this.feedbacksService.showFeedback(
        `Actualizando, por favor espere.`,
        'info'
      );
      this.api
        .UpdateCisterna({
          cisternaId: this.cisterna.cisternaId,
          uses: this.updateAttributeForm.value.uses,
        })
        .then((res) => {
          let feedbackMessage = `Éxito actualizando ${
            this.cisterna.__typename
          } ${this.commonsService.getIdentification(
            this.cisterna.sapId!,
            res.licensePlate
          )}.`;
          let feedbackType: keyof FeedbackClasses = 'success';
          this.feedbacksService.showFeedback(feedbackMessage, feedbackType);
        })
        .catch((error) => {
          let feedbackMessageType: 'info' | 'danger' = 'danger';
          let feedbackMessage = 'Error al actualizar' + error;
          this.feedbacksService.showFeedback(
            feedbackMessage,
            feedbackMessageType
          );
        });
    }
  }

  /**
   * Navega al formulario de edición de la Cisterna.
   * @return {Promise}
   */
  async onEditCisterna(): Promise<void> {
    const editionId: string = `${this.usersService.business.value.toUpperCase()}#CISTERNA#${
      this.cisterna.cisternaId
    }`;

    if (await this.editionsService.editionIsTaken(editionId)) {
      return;
    }

    this.router
      .navigate(['edit'], { relativeTo: this.route })
      .then(() => console.log('navigate to edit'));
  }

  /**
   * Ejecuta el modal de eliminación de una cisterna y lo
   * elimina en caso de aceptar.
   * @return {Promise}
   */
  async onDeleteCisterna(): Promise<void> {
    this.modalTitle = appConstants.cisterna.modalMessages.delete.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.delete.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage = appConstants.cisterna.modalMessages.delete.message;
    this.modalWithComment = false;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.cisternaModal
    );

    if (modalResult) {
      await this.cisternasService.deleteSelectedCisterna();

      this.router
        .navigate(['/', this.cisterna.business.toLowerCase(), 'cisternas'])
        .then(() => console.log('navigate to cisternas'));
    }
  }

  /**
   * Llama a refrescar la Cisterna seleccionada.
   */
  onRefreshCisterna(): void {
    this.updateSelectedCisterna().then(() =>
      console.log('Cisterna seleccionada actualizado.')
    );
  }

  /**
   * Colapsa o muestra el comentario del vehículo.
   */
  onViewComment(): void {
    this.showComment = !this.showComment;
  }

  /**
   * Retorna la clase que colapsa o muestra el comentario del vehículo.
   * @return {string} Clase CSS
   */
  showCommentClass(): string {
    return this.showComment ? 'show' : '';
  }

  /**
   * Inicializa el formulario de rechazo de una cisterna.
   * @private
   */
  private initCommentForm(): void {
    // Inicialización del formulario
    this.commentForm = this.formsService.generateCommentForm(
      this.isBeingRejected
    );
  }

  /**
   * Inicializa el formulario de archivado de una cisterna.
   * @private
   */
  private initArchiveForm(): void {
    let documents: Master[] = [];
    let validators: { [key: string]: FormValidators } = {};

    // El negocio Externos exige una carta aclaratoria para archivar.
    if (this.cisterna.business == 'FOREIGN') {
      // Agregamos la Carta Aclaratoria
      const index = this.master[`ARCHIVES#DOCUMENT_TYPES`].findIndex(
        (document: any): boolean => {
          return (
            document.valueId ===
            `${this.cisterna.business}_${appConstants.document.codes.explanatory_letter}`
          );
        }
      );
      const document: Master = this.master['ARCHIVES#DOCUMENT_TYPES'][index];
      documents.push(document);

      validators = {
        [document.valueId]: this.validatorsService.getDocumentValidatorForm(
          this.cisterna.center,
          true
        ),
      };
    }

    // Inicialización del formulario
    this.archiveForm = this.formsService.generateArchiveForm(
      documents,
      validators
    );
  }

  /**
   * Inicializa el formulario de actualización de
   * atributos de una Cisterna.
   * @private
   */
  private initUpdateAttributeForm(): void {
    // Inicialización del formulario
    this.updateAttributeForm = new FormGroup({
      center: new FormControl(this.cisterna.center, [Validators.required]),
    });
  }

  private initUpdateAttributeUsesForm(): void {
    // Inicialización del formulario
    this.updateAttributeForm = new FormGroup({
      uses: new FormControl<string[]>(this.cisterna.uses as Array<string>, {
        nonNullable: true,
        validators: [atLeastOneSelected],
      }),
    });
  }

  private initUpdateFuelsAttributesForm(): void {
    this.updateFuelsAttributesForm = new FormGroup({});

    switch (this.fuelAttributeToChange) {
      case 'SECCertificate':
        this.updateFuelsAttributesForm.addControl(
          'SECCertificate',
          new FormControl(this.cisterna.SECCertificate, [Validators.required])
        );
        break;

      case 'SECDate':
        this.updateFuelsAttributesForm.addControl(
          'SECDate',
          new FormControl(this.cisterna.SECDate, [
            Validators.required,
            maxDateTodayValidator(),
          ])
        );
        break;

      case 'SECFolio':
        this.updateFuelsAttributesForm.addControl(
          'SECFolio',
          new FormControl(this.cisterna.SECFolio, [Validators.required])
        );
        break;
    }
  }

  /**
   * Indica si una cisterna tiene documentos por vencer.
   * @return {boolean} Boolean que indica si la Cisterna tiene documentos por vencer.
   */
  hasToExpireDocuments(): boolean {
    const docNumber: number = this.cisterna.documentsToExpire || 0;
    return docNumber > 0;
  }

  /**
   * Indica si una cisterna tiene documentos vencidos.
   * @return {boolean} Boolean que indica si la Cisterna tiene documentos vencidos.
   */
  hasExpiredDocuments(): boolean {
    const docNumber: number = this.cisterna.documentsExpired || 0;
    return docNumber > 0;
  }

  /**
   * Retorna un color dependiendo del estado del envasado.
   * @return {string}
   */
  getColor(): string {
    return this.masterService.getSatusColor(this.cisterna.status);
  }

  /**
   * Retorna la fuente de imagen a mostrar en el Estado del envasado.
   * @return {string} ruta a imagen.
   */
  getImageSrc(status: string): string {
    return this.masterService.getImageSrc(status);
  }

  /**
   * Retorna una clase CSS dependiendo de la edad de la Cisterna.
   * @return {string}
   */
  getCisternaAgeClass(age: number): string {
    let cisternaAgeClass: string = '';
    if (this.business === 'foreign') {
      return cisternaAgeClass;
    }
    if (age >= appConstants.cisterna.ageToBeConsideredOld) {
      cisternaAgeClass = 'text-danger';
    }
    return cisternaAgeClass;
  }

  /**
   * Determina, con base al rol del usuario, cuáles botones mostrar.
   * @param {string} button Acción del botón.
   */
  showButton(button: string): boolean {
    let show: boolean = false;

    switch (button) {
      case 'delete':
      case 'archive':
        show = this.isAdmin;
        break;
      case 'edit-center':
        show =
          this.isAdmin &&
          (this.cisterna.business === 'LUBRICANTS' ||
            this.cisterna.business === 'FUELS');
        break;
      case 'edit-uses':
        show = this.isAdmin && this.cisterna.business === 'FUELS';
        break;
      case 'approve':
      case 'reject':
        show = this.isAdmin || this.isApprover;
        break;
      case 'actions':
      case 'edit':
        show = this.isAdmin || this.isCarrier;
        break;
      default:
        break;
    }
    return show;
  }

  /**
   * Define la situación de la Cisterna: ¿necesita aprobación?, ¿puede ser rechazado?
   * ¿Está bloqueado?
   * @private
   */
  private setCisternaSituation(): void {
    const cisternaToBeApprove: boolean =
      this.cisterna.status ===
      `${this.cisterna.business}_${appConstants.entity.codes.toBeApproved}`;
    const cisternaRejected: boolean =
      this.cisterna.status ===
      `${this.cisterna.business}_${appConstants.entity.codes.rejected}`;
    this.cisternaNeedsApproval = cisternaToBeApprove || cisternaRejected;
    this.cisternaCanBeRejected = cisternaToBeApprove;
    this.showBlockingMotives =
      this.cisterna.blockingMotives !== null &&
      this.cisterna.blockingMotives !== undefined &&
      this.cisterna.blockingMotives.length > 0 &&
      this.cisterna.status !==
        `${this.cisterna.business}_${appConstants.entity.codes.available}`;
    this.hasComment = !!this.cisterna.comment;
    this.showComment = false;
  }

  /**
   *
   */
  getcisternaArchive(archiveId: string) {
    this.archivesService.getArchiveById(archiveId).then((archivo) => {
      this.cisternaArchive = archivo;
    });
  }
  /**
   * Ejecuta el modal de detalles archivo
   */
  async onViewArchiveDetails() {
    await this.modalsService.showModal(
      <TemplateRef<any>>this.ArchiveDetailsModal
    );
  }

  async onDownloadArchiveDocument(): Promise<void> {
    let document: Document = appConstants.document.initialization;
    if (this.cisternaArchive) {
      document.name = `Documento Archivo - ${this.cisternaArchive.modelTypeName}`;
      document.s3Path = this.cisternaArchive.documents?.items[0]?.s3Path || '';
      document.archiveDocumentsArchiveId = this.cisternaArchive.archiveId;
      this.documentsService.setSelectedModel('ARCHIVE');
    }
    await this.documentsService.downloadDocument(document);
  }
  /**
   * Abre el modal de visualización de un documento.
   * @return {Promise}
   */
  async onViewDocumentArchive(): Promise<void> {
    this.isGettingURL = true;
    let document: Document = appConstants.document.initialization;

    this.modalTitle = 'Documento de Archivo';
    document.name = this.modalTitle;
    document.s3Path = this.cisternaArchive?.documents?.items[0]?.s3Path || '';

    await this.documentsService
      .getDocumentPreSignedURL(document)
      .then(async (): Promise<void> => {
        this.pdfSource = this.documentsService.documentPreSignedURL;
        await this.modalsService.showModal(
          <TemplateRef<any>>this.documentViewer,
          true
        );
      });
  }
  pageRendered(): void {
    this.isGettingURL = false;
  }

  hasDocumentOnArchive(): boolean {
    return this.cisternaArchive?.documents?.items[0]?.s3Path ? true : false;
  }

  getAgrement(entityID: string) {
    this.api
      .CommercialAgreementsByStatusAndAgreementId(
        this.business.toUpperCase() + this.commercialAgreementsStatuces.active,
        undefined,
        undefined,
        { entityId: { eq: entityID } },
        100
      )
      .then((res) => {
        if (res.items.length > 0) {
          this.agreement = res.items[0];
          this.hasAgrement = true;
        }
      });
  }

  hasAccessAC(): boolean {
    let isAC =
      this.usersService.isAcN1 ||
      this.usersService.isAcCreator ||
      this.usersService.isAcN2;
    if (this.isAdmin || this.isCarrier || isAC) {
      return true;
    }
    return false;
  }
  OnReprocesiing(): void {
    if (!this.isAdmin && !this.isReprocesingAvailable()) {
      return;
    }
    this.isGettingCisterna = true;
    this.api
      .UpdateCisterna({
        cisternaId: this.cisterna.cisternaId,
        status: `${this.cisterna.business}_${appConstants.entity.codes.toBeApproved}`,
      })
      .then((response) => {
        console.log(response);
        this.api.UpdateCisterna({
          cisternaId: this.cisterna.cisternaId,
          status: `${this.cisterna.business}_${appConstants.entity.codes.inProcess}`,
        });
        this.isGettingCisterna = false;
      });
  }

  isReprocesingAvailable(): boolean {
    if (this.cisterna.status.endsWith('_0000004')) {
      return isReprocesingAvailable(this.cisterna.updatedAt);
    }
    return false;
  }

  async onUpdateCisternaFuelsAttributes(
    attributeToChange: 'SECDate' | 'SECFolio' | 'SECCertificate' | null
  ): Promise<void> {
    this.fuelAttributeToChange = attributeToChange;
    this.initUpdateFuelsAttributesForm();

    this.modalTitle = appConstants.cisterna.modalMessages.edit.title;
    this.modalQuestion =
      appConstants.cisterna.modalMessages.edit.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.cisterna.sapId!,
          this.cisterna.licensePlate
        )
      );
    this.modalMessage =
      appConstants.cisterna.modalMessages.edit.message.replace('y SAP', '');

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.updateCisternaFuelsAttributesModal
    );

    if (modalResult) {
      if (this.updateFuelsAttributesForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }
      this.feedbacksService.showFeedback(
        `Actualizando, por favor espere.`,
        'info'
      );
      this.api
        .UpdateCisterna({
          cisternaId: this.cisterna.cisternaId,
          SECFolio: this.updateFuelsAttributesForm.value.SECFolio,
          SECDate: this.updateFuelsAttributesForm.value.SECDate,
          SECCertificate: this.updateFuelsAttributesForm.value.SECCertificate,
        })
        .then((res) => {
          let feedbackMessage = `Éxito actualizando ${
            this.cisterna.__typename
          } ${this.commonsService.getIdentification(
            this.cisterna.sapId!,
            res.licensePlate
          )}.`;
          let feedbackType: keyof FeedbackClasses = 'success';
          this.feedbacksService.showFeedback(feedbackMessage, feedbackType);
        })
        .catch((error) => {
          let feedbackMessageType: 'info' | 'danger' = 'danger';
          let feedbackMessage = 'Error al actualizar' + error;
          this.feedbacksService.showFeedback(
            feedbackMessage,
            feedbackMessageType
          );
        });
    }
  }

  private get capacityParts(): string[] {
    const raw = this.cisterna?.capacity || '';
    return raw.split('_')[1]?.split('#') || [];
  }

  get volumeToDisplay(): string {
    return this.capacityParts[0] || '';
  }

  get capacitiesDisplay(): string[] {
    return this.capacityParts.slice(1);
  }

  ngOnDestroy(): void {
    this.selectedCisternaChangedSubscription.unsubscribe();
    this.onUpdateCisternaListener.unsubscribe();
    this.requestSucceededSubscription.unsubscribe();
    console.log('cisterna-details.component subscriptions removed.');
  }
}
